import { crudTable, date, index, integer, text } from "@-/dev.improve.haniverse.lib.database.table";
import { sql } from "@-/com.npmjs.drizzle-orm";

/** A single review session for an actor-owned user card. */
export const userCardReviewTable = crudTable(
  "user_card_review",
  {
    // A parent id, not a FOREIGN KEY: see `ACTOR_TABLE_PARENTS` (the cloud copy would enforce one).
    cardId: text("card_id").notNull(),
    fsrsCardReviewLogId: text("fsrs_card_review_log_id").notNull(),
    /**
     * Han (the in-app currency, 1 Han = ¥1) this review earned. The balance sums the live rows, so
     * undoing (soft-deleting) the review takes its Han back. Null on reviews written before Han
     * existed: earning is not retroactive.
     */
    hanEarned: integer("han_earned"),
    reviewedAt: date("reviewed_at").notNull(),
    /**
     * Review recharge (0–100) right after this review: the previous balance plus the review's
     * points, capped at 100. The current balance is the latest such value across reviews and
     * introductions, so undoing (soft-deleting) this row restores the balance before it exactly.
     * Null on reviews written before review recharge was stored.
     */
    reviewRechargeAfter: integer("review_recharge_after"),
  },
  // Both columns back relation joins: `cardId` ← `userCard.userCardReviews`,
  // `fsrsCardReviewLogId` ← `fsrsCardReviewLog.userCardReview`.
  (table) => [
    index("user_card_review_card_id_idx").on(table.cardId),
    index("user_card_review_fsrs_card_review_log_id_idx").on(table.fsrsCardReviewLogId),
    // Partial index on `reviewed_at` for the learn/drill review-progress
    // "reviewed today" count, which filters `deleted_at IS NULL` plus a
    // `reviewed_at` day range. Without it that count did a full
    // `SCAN user_card_review` (~75ms); the index makes it a range search.
    index("user_card_review_reviewed_at_idx")
      .on(table.reviewedAt)
      .where(sql`${table.deletedAt} is null`),
    // Partial index for the Han balance sum, which only reads live rows that earned Han.
    index("user_card_review_han_earned_idx")
      .on(table.hanEarned)
      .where(sql`${table.deletedAt} is null and ${table.hanEarned} is not null`),
  ],
);

export type UserCardReview = typeof userCardReviewTable.$inferSelect;
